<template>
  <el-table-column
    prop="deadline"
    sortable="custom"
    label="Dátum"
    show-overflow-tooltip
    width="200px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.deadline">{{ scope.row.deadline | date }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'deadline',
  };
</script>
